export const EXPERIMENT_NEW_LANGUAGES = 'specs.wixForum.NewLanguages';
export const EXPERIMENT_DISABLE_ASDK = 'specs.wixForum.DisableASDK';
export const EXPERIMENT_DISABLE_FIX_VIEWPORT = 'specs.wixForum.DisableFixViewport';
export const EXPERIMENT_CODE_BLOCK = 'specs.wixForum.CodeBlock';
export const EXPERIMENT_HASHTAGS = 'specs.wixForum.Hashtags';
export const EXPERIMENT_USE_NAVIGATE_TO_SECTION = 'specs.wixForum.UseNavigateToSection';
export const EXPERIMENT_INSTALL_MEMBERS = 'specs.wixForum.InstallMembersApp';
export const EXPERIMENT_SWITCH_NOTIFICATIONS_SERVICE = 'specs.wixForum.SwitchNotificationsService';
export const EXPERIMENT_UPGRADE_WITH_AUTOSAVE = 'specs.wixForum.UpgradeWithAutosave';
export const EXPERIMENT_MEMBERS_AREA = 'specs.wixForum.MembersArea';
export const EXPERIMENT_HEADER_TOGGLE = 'specs.wixForum.HeaderToggle';
export const EXPERIMENT_TOP_COMMENT = 'specs.wixForum.TopComment';



// WEBPACK FOOTER //
// ./app/constants/experiments.js